export default __webpack_public_path__ + "static/media/santa.313611dc.png";